<template>
  <div>
    <div class="gansuass" @click.self="cancelQRcodeImg">
        <div class="header">
            <div class="header-nav clearfix">
                <div class="gansu-img">
                    <img :src="getImgUrl(collegeInfo.logo)" class="gansu-icon">
                    <!-- <img src="../assets/images/icon.png" class="gansu-icon"> -->
                </div>
                <div class="header-title">
                    <p class="gansu-title">{{collegeName}}测评平台</p>
                    <p class="gansu-title-des">{{collegeEnglishName}}</p>
                </div>
                <div class="header-tool">
                    <div class="login-btn-box clearfix"><div class="login-btn" @click="loginBtn">管理员登录</div></div>
                    <div class="search-ipt">
                        <input type="text" class="search" placeholder="请输入测评名称" v-model="searchKeyword" @keyup.enter="getInputValue">
                        <div class="search-icon" @click="getInputValue"></div>
                        <!-- <img src="../assets/images/search.png" class="search-icon" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="main" style="background-color:#fff;">
            <!-- <ul class="clearfix" :class="(searchActsList.length !== 0) ? 'd-none' : 'd-block'"> -->
            <ul class="clearfix">
                <li v-for="(item, index) in searchActsList" :key="index" @click="getActsQRcode(item.id, index)" style="background-color:#F2F2F2;">
                    <div class="acts-title">{{item.name}}</div>
                    <div class="acts-item-icon">
                        <div class="QRcode">
                            <div class="QRcode-img-box" @click="goShowQRcode(item.id, item.QRcodeImgUrl, item.name, index)" v-show="QRcodeIndex === index && item.QRcodeImgUrl !== ''">
                                <img class="QRcode-img" :src="item.QRcodeImgUrl" alt="">
                                <div class="QRcode-img-des">微信扫一扫进入测评</div>
                            </div>
                        </div>
                        <div class="acts-item-line"></div>
                        <div class="people-numbers">
                            <div class="people-numbers-box"><span class="people-numbers-img" alt=""></span><span class="numbers">{{item.enrollNum}}</span></div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="no-search-result" v-if="searchActsList.length === 0">当前无数据</div>
        </div>
        
    </div> 
    <div class="model" v-if="showModel" @touchmove.prevent>
        <div class="loginBox">
            <div class="login-title">登录<span class="close" @click="cancelLogin">×</span></div>
            <div class="login-list">
                <div class="loginTip" v-if="loginTips !== ''" v-html="loginTips"></div>
                <div class="login-name">
                    <span class="required">*</span>
                    <label for="name">登录名</label>
                    <input type="text" id="name" v-model.trim="name" autofocus @keyup.enter="successLogin">
                    <p class="tips" v-html="nameTip"></p>
                </div>
                <div class="login-password">
                    <span class="required">*</span>
                    <label for="password">密码</label>
                    <input type="password" id="password" v-model.trim="password" @keyup.enter="successLogin">
                    <p class="tips" v-html="passwordTip"></p>
                </div>
            </div>
            <div class="login-Button">
                <div class="login-Button-cancel" @click="cancelLogin">取消</div>
                <div class="login-Button-confirm" @click="successLogin">确定</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import 'amfe-flexible'
// import Cookies from 'js-cookie'

export default {
  data() {
    return{
      userId: this.$route.params.userId,
      collegeInfo: {}, // 学院信息
      collegeName: '', // 学院测评平台中文名
      collegeEnglishName: '', // 学院测评平台英文名
      user: {}, // 用户信息
      actsList: [], // 测评列表
      searchKeyword: '', // 搜索关键字
      searchActsList: [], // 查询测评结果列表
      nosearchResult: '', // 查询无结果
      QRcodeUrl: '', // 获取测评二维码
      QRcodeIndex: -1, // 获取当前测评下标
      showModel: false, // 登录窗口
      name: '', // 登录名
      password: '', // 登录密码
      nameTip: '', // 登录名提示
      passwordTip: '', // 登录密码提示
      loginTips: '', // 登录错误提示
    }
  },
  created() {
   this.$nextTick(() => {
       // 获取学院信息
       this.getCollegeInfo()
       // 获取测评信息
       this.getActiveActs()
   })
  },
  watch: {
      searchKeyword(newValue) {
          if(newValue === '') {
              this.searchActsList = this.actsList
          }
      }
  },
  mounted() {
    
  },
  methods: {
    // 获取图片路径
    getImgUrl(imgUrl) {
        return `https://kclass.krcedu.com:81/file/${imgUrl}`
    },
    // 获取学院信息
    async getCollegeInfo() {
        let res = await this.$axios.get(`REST/getClientInfo?userId=${this.userId}`)
        if(res.status === 200) {
            this.collegeInfo = res.data.client
            this.user = res.data.user
            if(this.collegeInfo.name.indexOf(" ") == -1) {
                this.collegeName = this.collegeInfo.name
            } else {
                this.collegeName = this.collegeInfo.name.split(' ')[0]
                this.collegeEnglishName = this.collegeInfo.name.slice(this.collegeInfo.name.indexOf(' ') + 1)
            }
        }
        document.title = this.collegeInfo.name + '测评平台'
    },
    // 获取测评信息
    async getActiveActs() {
        let res = await this.$axios.get(`REST/searchMyActiveActs?userId=${this.userId}`)
        if(res.status === 200) {
            this.actsList = res.data.map((e) => {
                e.QRcodeImgUrl = ''
                return e
            })
        }
        this.searchActsList = this.actsList
    },
    // 获取测评二维码
    async getActsQRcode(actId, index) { 
        this.QRcodeIndex = index
        if(this.searchActsList[index].QRcodeImgUrl !== '') return
        let res = await this.$axios.get(`REST/getAssQR?imgSize=300&actId=${actId}`)
        if(res.status === 200) {
            this.searchActsList[index].QRcodeImgUrl = `https://kclass.krcedu.com:82/kclass/${res.data.qrImgUrl}`
        }
            
    },
    // 管理员登录
    loginBtn() {
        this.showModel = true
    },
    // 获取input值
    getInputValue() {
        this.searchActsList = []
        this.nosearchResult = ''
        this.actsList.forEach(element => {
            if(element.name.match(this.searchKeyword) !== null) {
                this.searchActsList.push(element)
                
            } else {
                this.nosearchResult = "未找到此测评"
            }
        })
    },
    // 关闭二维码图片
    cancelQRcodeImg() {
        this.QRcodeIndex = -1
    },
    // 点击二维码进入大图页面
    goShowQRcode(actId, QRcodeimgUrl, name, index) {
        this.getActsQRcode(actId, index)
        let routeUrl = this.$router.resolve({name: 'QRcode', params: {imgUrl: QRcodeimgUrl, assName: name}})
        window.open(routeUrl .href, '_blank')
    },
    // 取消登录
    cancelLogin() {
        this.showModel = false
    },
    // cookie
    createCookie(name, value, mins) {
        var expires;
        mins = mins || 60 * 12; //12 hours by default
        var date = new Date();
        date.setTime(date.getTime() + (mins * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + encodeURI(value) + expires + "; path=/";
    },
    // 登录成功
    successLogin() {
        this.loginTips = ''
        if(this.name === '') {
            if(this.name === '' && this.password === '') {
                this.nameTip = '请完整填写登录名'
                this.passwordTip = '请完整填写密码'
            } else {
                this.nameTip = '请完整填写登录名'
            }                     
        } else {
            this.nameTip = ''
        }

        if(this.password === '') {
            if(this.password === '' && this.name === '') {
                this.nameTip = '请完整填写登录名'
                this.passwordTip = '请完整填写密码'
            } else {
                this.passwordTip = '请完整填写密码'
            }                     
        } else {
            this.passwordTip = ''
        }

        if(this.name !== '' && this.password !== '') {
            this.$axios.get(`BIZREST/login?name=${this.name}&password=${this.password}`).then(res => {
                if (res.data.token === 'INVALID-0' || res.data.token === 'INVALID-2') {
                    this.loginTips = '无效的用户名或密码。'
                } else if (res.data.token === 'INVALID-1') {
                    this.loginTips ='该用户已经被禁止登陆，请联系您的管理员。'
                } else if (res.data.token === 'INVALID-3') {
                    this.loginTips = res.data.error
                } else {
                    let token = encodeURIComponent(res.data.token)
                    window.location.href = `https://kclass.krcedu.com/index.html?root=my&token=${token}`;
                }
            })
        }
    }
  }
}
</script>

<style scoped>
.model {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 999;
}
.loginBox {
    width: 600px;
    /* height: 300px; */
    background: #fff;
    border-radius: 10px;
    margin: 15vh auto 0;
}
.login-title {
    padding: 12px 20px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 18px;
    font-weight: bold;
}
.close {
    display: block;
    float: right;
    font-size: 20px;
    color: #999;
    cursor: pointer;
}
.close:hover {
    color: #333;
}
.login-list {
    padding: 30px 20px 40px;
}
.loginTip {
    width: 80%;
    margin: 0 auto 30px;
    text-align: center;
    padding: 20px 20px;
    border: 1px solid rgba(240, 211, 215, 1);
    background: rgba(244, 222, 222, 1);
    border-radius: 10px;
    color: rgba(192, 74, 75, 1);
}
.login-name {
    padding-left: 25px;
    /* height: 50px; */
    position: relative;
    margin-bottom: 30px;
}
.required {
    position: absolute;
    top: 4px;
    left: 0;
    color: #f00;
    font-size: 20px;
}
label {
    display: inline-block;
    font-size: 15px;
    width: 120px;
}
input {
    width: 250px;
    height: 30px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    outline: none;
    box-sizing: border-box;
}
.tips {
    position: absolute;
    top: 30px;
    left: 146px;
    font-size: 12px;
    color: #f00;
}
.login-password {
    padding-left: 25px;
    position: relative;
}
.login-Button {
    /* height: 48px; */
    border-top: 1px solid #e5e5e5;
    text-align: right;
    padding: 10px 20px;
    font-size: 14px;
}
.login-Button-cancel {
    display: inline-block;
    padding: 6px 12px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    background: #e4e8ea;
    margin-right: 10px;
    cursor: pointer;
}
.login-Button-confirm {
    display: inline-block;
    padding: 6px 12px;
    border: 1px solid rgba(21, 52, 109, 1);
    border-radius: 5px;
    background: rgba(21, 52, 109, 1);
    color: #fff;
    cursor: pointer;
}
.d-block {
    display: block !important;
}
.d-none {
    display: none !important;
}
.gansuass {
    width: 100%;
    min-width: 375px;
    margin-bottom: 300px;
}
.clearfix:after{
  content:"";
  display:block;
  height:0;
  clear:both;
  visibility:hidden;  
}
p {
    margin: 0;
}
@media screen and (min-width: 1000px) {
    .header {
        width: 100%;
        height: 160px;
        background: rgba(21, 52, 109, 1);
        border-top: 1px solid rgba(21, 52, 109, 1);
        overflow: hidden;
    }
    .header-nav {
        width: 1000px;
        height: 88px;
        margin: 36px auto 0;
    }
    .gansu-img {
        float: left;
        width: 88px;
        height: 88px;
    }
    .gansu-icon {
        width: 100%;
        height: 100%;
    }
    .header-title {
        float: left;
        padding: 19px 0 0 11px;
        color: #fff;
    }
    .header-title .gansu-title{
        font-size: 24px;
        font-weight: 500;
    }
    .header-title .gansu-title-des {
        font-size: 12px;
        font-weight: 500;
    }
    .header-tool {
        float: right;
        padding-top: 4px;
        position: relative;
        height: 100%;
        box-sizing: border-box;
    }
    .header-tool::after {
        content: '';
        position: absolute;
        top: 8px;
        right: 0px;
        width: 104px;
        height: 28px;
        background: rgba(60, 95, 159, 1);
    }
    .login-btn-box {
        width: 100%;
        height: 28px;
        margin-bottom: 16px;
    }
    .login-btn {
        float: right;
        height: 28px;
        line-height: 28px;
        width: 104px;
        font-size: 14px;
        color: rgba(21, 52, 109, 1);
        background: #fff;
        text-align: center;
        position: relative;
        margin-right: 4px; 
        z-index: 9;
        cursor: pointer;
    }
    .search {
        background: rgba(21, 52, 109, 1);
        border: 1px solid rgba(240, 240, 240, 0.8);
        box-sizing: border-box;
        height: 36px;
        width: 400px;
        padding: 0 36px 0 12px;
        color: rgba(240, 240, 240, 0.8);
        outline: none;
    }
    .search::placeholder {
        font-size: 12px;
        color: rgba(240, 240, 240, 0.8);
    }
    .search-ipt {
        position: relative;
    }
    .search-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 36px;
        height: 36px;
        background: url(../assets/images/search.png) center center no-repeat;
        background-size: 22px 22px;
        /* background-repeat:no-repeat; */
    }
}
@media screen and (max-width: 999px) {  
    .header {
        width: 100%;
        background: rgba(21, 52, 109, 1);
        border-top: 1px solid rgba(21, 52, 109, 1);
        overflow: hidden;
    }
    .header-nav {
        padding: 10px 12px 12px;
    }
    .gansu-img {
        width: 60px;
        height: 60px;
        margin: 0 auto 5px;
    }
    .gansu-icon {
        width: 100%;
        height: 100%;
    }
    .header-title {
        color: #fff;
        text-align: center;
    }
    .header-title .gansu-title{
        font-size: 18px;
        font-weight: 500;
    }
    .header-title .gansu-title-des {
        font-size: 12px;
    }
    .header-tool {
        margin: 12px auto 0;
        width: 350px;
    }
    .login-btn-box {
        display: none;
    }
    .search {
        display: block;
        background: rgba(21, 52, 109, 1);
        border: 1px solid rgba(240, 240, 240, 0.8);
        box-sizing: border-box;
        height: 32px;
        width: 350px;
        margin: 0 auto;
        padding: 0 32px 0 12px;
        color: rgba(240, 240, 240, 0.8);
        outline: none;
    }
    .search::placeholder {
        font-size: 12px;
        color: rgba(240, 240, 240, 0.8);
    }
    .search-ipt {
        position: relative;
    }
    .search-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 32px;
        height: 32px;
        background: url(../assets/images/search.png) center center no-repeat;
        background-size: 18px 18px;
    }
    .main {
        width: 664px;
    }
}
@media screen and (max-width: 665px) {
    .main {
        width: 332px;
    }
}

.main {
    max-width: 1000px;
    margin: 70px auto;
}
ul {    
    padding: 0;   
    /* text-align: center; */
}
ul li {
    float: left;
    list-style: none;
    width: 332px;
    height: 170px;
    /* display: inline-block; */
    border: 1px solid rgba(21, 52, 109, 0.1);
    box-sizing: border-box;
    padding: 58px 0 25px 0;
    cursor: pointer;
    /* transition: transform 1s; */
}
/* ul li:nth-child(3n){
    border-right: none;
} */
.acts-title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 10px;
}
.acts-item-icon {
    height: 18px;
    margin-top: 45px;
}
.QRcode {
    float: left;
    height: 18px;
    width: 164px;
    background: url(../assets/images/QRcode.png) center center no-repeat;
    background-size: 18px 18px;
    position: relative;
}
.QRcode-img-box {
    position: absolute;
    top: 8px;
    left: 80px;
    background: #fff;
    border: 1px solid rgba(21, 52, 109, 0.1);
    z-index: 99;
    animation:showbox 1s;
}
@keyframes showbox
{
	from {transform: scale(0);-webkit-transform-origin: 0 0 0;}
	to {transform: scale(1);-webkit-transform-origin: 0 0 0;}
}
.QRcode-img {
    width: 300px;
    height: 300px;
    /* transition: transform 1s; */
}
.QRcode-img-des {
    padding-bottom: 20px; 
    color: #666;
    text-align: center;
    font-size: 14px;
}
.acts-item-line {
    float: left;
    width: 2px;
    height: 14px;
    background: rgba(240, 240, 240, 1);
    margin-top: 2px;
}
.people-numbers {
    float: left;
    height: 18px;
    width: 164px;
}
.people-numbers-box {
    text-align: center;
}
.people-numbers-img {
    display: inline-block;
    margin: 0 auto;
    width: 18px;
    height: 18px;
    background: url(../assets/images/numbers.png) center center no-repeat;
    background-size: 18px 18px;
}
.people-numbers-box .numbers {
    font-size: 14px;
    color: rgba(21, 52, 109, 1);
    position: relative;
    top: -3px;
    left: 5px;
}
ul li:hover {
    background-image: linear-gradient(-45deg, rgba(21, 52, 109, 1),rgba(44, 80, 145, 1));
    border: 1px solid #fff;
    box-shadow: 0px 0px 40px 0px rgba(21, 52, 109, 0);
    /* transition:  */
    /* transform: scale(1.05); */
    color: #fff;
    z-index: 99;
}
ul li:hover .acts-title {
    color: #fff;
}
ul li:hover .QRcode {
    background: url(../assets/images/QRcodeWhite.png) center center no-repeat;
    background-size: 20px 20px;
}
ul li:hover .acts-item-line {
    background: rgba(83, 116, 177, 1);
}
ul li:hover .people-numbers-img {
    background: url(../assets/images/numbersWhite.png) center center no-repeat;
    background-size: 20px 20px;
}
ul li:hover .people-numbers-box .numbers {
    color: #fff;
}
.no-search-result {
    text-align: center;
    /* font-size: 30px; */
    color: #999;
}
</style>
